import { Component, h, Prop, Watch } from '@stencil/core';
import debounce from 'debounce';

interface UiCmsSuperteaserVideoBody {
  videoSrc: string;
}

@Component({
  tag: 'ui-cms-superteaser-video',
})
export class UiCmsSuperteaserVideo {
  @Prop({ mutable: true }) body: UiCmsSuperteaserVideoBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  superteaser: HTMLElement;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  setFullWidth() {
    this.superteaser.style.width = `${window.innerWidth}px`;
  }

  componentDidLoad() {
    // This is needed because safari does not recalculate vw correctly on resize
    const setWidthDebounced = debounce(this.setFullWidth.bind(this), 100);
    window.addEventListener('resize', setWidthDebounced);
  }

  render() {
    return (
      <ui-superteaser
        mediaType="movingImage"
        videoSrcId={this.body.videoSrc}
        videoLoopSetting="no-loop"
        style={{ width: `${window.innerWidth}px` }}
        ref={(el) => {
          this.superteaser = el;
        }}
        variant="medium"
      ></ui-superteaser>
    );
  }
}
